import { useState, useCallback } from 'react';

// Configuración de la impresora térmica (ancho del papel).
// 58mm (XP-58 y similares) o 80mm (la mayoría de POS). También admite ancho personalizado.

export interface PrinterConfig {
  paperWidth: number; // en mm (ej. 58, 80)
}

const STORAGE_KEY = 'printer_config';

const DEFAULTS: PrinterConfig = { paperWidth: 80 };

export function getPrinterConfig(): PrinterConfig {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return { ...DEFAULTS, ...JSON.parse(raw) };
  } catch { /* ignore */ }
  return DEFAULTS;
}

export function savePrinterConfig(cfg: PrinterConfig) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(cfg));
  } catch { /* ignore */ }
}

/** Métricas derivadas del ancho del papel para renderizar el ticket. */
export function getTicketMetrics(paperWidth: number) {
  // Ancho imprimible aprox. (descontando márgenes del cabezal)
  // 58mm ≈ 32 caracteres a 12cpi; 80mm ≈ 48 caracteres
  const chars = paperWidth <= 58 ? 32 : paperWidth <= 80 ? 48 : Math.round(paperWidth * 0.6);
  const fontSize = paperWidth <= 58 ? 11 : 12;
  return { widthMm: paperWidth, chars, fontSize };
}

export function usePrinterConfig() {
  const [config, setConfig] = useState<PrinterConfig>(getPrinterConfig);

  const save = useCallback((next: PrinterConfig) => {
    savePrinterConfig(next);
    setConfig(next);
  }, []);

  return { config, save };
}
